/**
 * @desc 识别营业执照图片信息
 */
import { OcrOptions } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type RecognizeBusinessLicenseParameter = OcrOptions

const method = 'POST'
const url = '/nexus/ocr/recognizeBusinessLicense'

export const recognizeBusinessLicenseApi = (
  data?: RecognizeBusinessLicenseParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    data,
    ...config
  })
}

recognizeBusinessLicenseApi.method = method
recognizeBusinessLicenseApi.url = url
